/**
 * Rechercher un thème dans un autre thème en recherchant également dans les thèmes parents
 * @param theme Thème principal
 * @param searchedTheme Thème recherché
 * @returns {boolean}
 */
function isInTheme(theme, searchedTheme) {
  // Vérifier si le thème est celui recherché
  if (searchedTheme['@id'] === theme['@id']) {
    return true;
  }
  // Vérifier si le thème contient un thème parent
  if (typeof theme.parent !== 'undefined' && theme.parent !== null) {
    return isInTheme(theme.parent, searchedTheme)
  } else {
    return false; // Le thème recherché n'a pas été trouvé et il n'y a pas de thème parent
  }
}

export default isInTheme;
